import * as React from 'react';
import { Checkbox } from 'antd';
import { IWidget } from 'common/schema/widget/Widget';
import { getWidgetCheckboxOptions } from '../helper/getWidgetCheckboxOptions';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { CheckboxGroupInput } from 'client/ui/form/input/CheckboxGroupInput';

export interface FormWidgetInputMultipleChoiceViewProps {
  widget: IWidget;
}

export function FormWidgetInputMultipleChoiceView(
  props: FormWidgetInputMultipleChoiceViewProps
) {
  const { widget } = props;

  // Abbiamo un singolo metadato per i campi di testo
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  return (
    <FormWidgetItem name={name} widget={props.widget}>
      <CheckboxGroupInput
        name={name}
        options={getWidgetCheckboxOptions(props.widget)}
      />
    </FormWidgetItem>
  );
}
